import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';



Snappy.Component.EduFeedback = class EduFeedback extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-feedback';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
    }

    setVars() {
        this.$document = $(document);
        this.$container = this.$element.find('.js-feedback-container');
        this.$items = this.$element.find('.js-feedback-item');
        this.endPoint = this.$element.data('url');
        this.$counts = this.$element.find('.js-feedback-count');
        this.isLoggedIn= this.$element.data('isLoggedIn') === 'True';

    }

    setEventListeners() {
        this.$container.on('change', this.changeHandler.bind(this));
    }



    changeHandler(e) {
        if (!this.isLoggedIn) {
            $(window).trigger('IR:openSingIn');
            return;
        }
        const formData = this.$container.serialize();
        const target = e.target;
        this.trackCheckbox(target);
        $.ajax({
            url: this.endPoint,
            type: 'POST',
            data: formData,
            success: this.handleSuccess.bind(this),
            error: this.handleError.bind(this)
        });

    }

    handleSuccess(response) {

        if (response.success === true) {
            const feedBackObj = response.feedback;
            const keys = Object.keys(feedBackObj);
            keys.forEach((key) => {
                const $currentCount = this.$counts.filter(`[data-name=${key.toLowerCase()}]`);
                if ($currentCount.length) {
                    $currentCount.text(feedBackObj[key]);
                }
            });
        } else {
            this.handleError(response);
        }
    }

    handleError(response) {
        console.log(response);
        alert('Something went wrong');
    }

    trackCheckbox(target) {
        if (!target.checked) {
            return;
        }
       
        const category = target.getAttribute('data-gtm-event-category');
        const action = target.getAttribute('data-gtm-event-action');
        const label = target.getAttribute('data-gtm-event-label');
        $(window).trigger('gtm:send', [ category, action, label]);
    }



};



// WEBPACK FOOTER //
// ./components/edu-feedback/scripts/edu-feedback.js